<template>
  <div class="home">
    <b-container>
      <div class="mt-3 mb-3">
        <b-img :src="require('@/assets/sbp_logo.png')" ></b-img>
      </div>
      <div class="mt-3">
        <div class="markdown-viewer">
          <div class="preview_mode">
            <div class="markdown-body" v-html="bind_data.md_text"></div>
          </div>
        </div>

      </div>

    </b-container>
  </div>
</template>

<script>
import markdownit from 'markdown-it';
import axios from 'axios';
//import sbp_md from "raw-loader!../../public/md/sbp.md";
//import onerepo_md from "raw-loader!../../public/md/onerepo.md";
//import jrcrepo_md from "raw-loader!../../public/md/jrcrepo.md";

export default {
  name: 'HomeView',
  components: {
  },
  // ローカルデータ変数
  data() {
    return {
      markdownit: null, //マークダウンオブジェクト
      bind_data: {
        md_text: "",
      },
      local_data: {
        sbp_md: "",
        onerepo_md: "",
        jrcrepo_md: "",
      },
      state_data: {
      }
    }
  },
  // 既定計算
  computed: {
  },
  // インスタンス初期化後
  created(){
    this.markdownit = new markdownit();
  },
  // インスタンス破棄後
  destroyed: function() {
  },
  // インスタンスマウント後
  async mounted(){
    if( this.local_data.onerepo_md !== null && this.$route.path.toLowerCase().indexOf("onerepo") > 0  ){
      let onerepo_md = await axios.get("/md/onerepo.md");
      this.local_data.onerepo_md = onerepo_md.data;
      // console.log("onerepo_md:"+onerepo_md)
      this.bind_data.md_text = this.markdownit.render(this.local_data.onerepo_md);
    }
    else if( this.local_data.jrcrepo_md !== null && this.$route.path.toLowerCase().indexOf("jrcrepo") > 0 ){
      let jrcrepo_md = await axios.get("/md/jrcrepo.md");
      this.local_data.jrcrepo_md = jrcrepo_md.data;
      // console.log("jrcrepo_md:"+jrcrepo_md)
      this.bind_data.md_text = this.markdownit.render(this.local_data.jrcrepo_md);
    }
    else{
      let sbp_md = await axios.get("md/sbp.md");
      this.local_data.sbp_md = sbp_md.data;
      //console.log("sbp_md:"+JSON.stringify(this.local_data));
      this.bind_data.md_text = this.markdownit.render(this.local_data.sbp_md);
    }
  }
}
</script>

<style scoped>
.markdown-viewer {
  text-align: left;
  padding: 4px;
}
.preview_mode {
  box-sizing: border-box;
  margin: 24px 12px 24px 0px;
}
</style>